import classNames from 'classnames';
import { graphql } from 'gatsby';
import { Link } from 'gatsby-plugin-react-i18next';

export type ProductCardProps = {
  category: string;
  colorScheme?: string;
  product: Queries.ProductCardFragment;
};

export const ProductCard = ({
  category,
  colorScheme,
  product,
}: ProductCardProps) => (
  <section className={classNames('product-card', colorScheme)}>
    <Link to={`/categories/${category}/products/${product.slug}`}>
      <div
        className='image'
        style={{
          backgroundImage: product.featured_image
            ? `url(${product.featured_image!.localFile!.publicURL!})`
            : undefined,
        }}
      />
      <h3>{product.title}</h3>
      <p className='sku'>{product.subtitle!}</p>
    </Link>
  </section>
);

export const query = graphql`
  fragment ProductCard on STRAPI_PRODUCT {
    featured_image {
      alternativeText
      localFile {
        publicURL
      }
    }
    id
    slug
    subtitle
    title
  }
`;
